import React, { useEffect, useState } from 'react';
import { NumberField } from '@adobe/react-spectrum';
import { I18nProvider } from 'react-aria';

const TipInput = ({ tipAmount, setTipAmount, minTip, maxTip, currency, locale, name, setName, message, setMessage, displayName }) => {
    // A visually hidden class to ensure labels are accessible to screen readers
    const visuallyHiddenClass = {
        position: 'absolute',
        width: '1px',
        height: '1px',
        margin: '-1px',
        padding: '0',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        border: '0',
    };

    const [tipError, setTipError] = useState('');
    // const [inputWidth, setInputWidth] = useState(window.innerWidth < 768 ? '165px' : '111px');
    const [inputWidth, setInputWidth] = useState(window.innerWidth < 768 ? '100%' : '111px');

    useEffect(() => {
        const handleResize = () => {
            setInputWidth(window.innerWidth < 768 ? '100%' : '111px');
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleTipChange = (newValue) => {
        setTipAmount(newValue);
        if (newValue < minTip) {
            setTipError(`Please enter at least ${Intl.NumberFormat(locale, { style: 'currency', currency: currency.toUpperCase() }).format(minTip)}`);
        } else if (newValue > maxTip) {
            setTipError(`The maximum tip is ${Intl.NumberFormat(locale, { style: 'currency', currency: currency.toUpperCase(), minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(maxTip)}`);
        } else {
            setTipError('');
        }
    };

    return (
        <div style={{ colorScheme: 'light' }}>
            {/* <h2 className="text-2xl font-bold mb-4">Support {displayName}</h2> */}
            <div className="mb-4">
                <div className="md:flex md:items-center md:space-x-4">
                    <label htmlFor="tipAmount" className="text-sm font-medium text-gray-700 whitespace-nowrap">
                        Choose amount:
                    </label>
                    <div className="max-md:flex max-md:justify-center md:flex md:items-center">
                        <I18nProvider locale={locale}>
                            <NumberField
                                // label="Suggested tip"
                                value={tipAmount || ''}
                                onChange={handleTipChange}
                                minValue={0}
                                width={inputWidth}
                                formatOptions={{
                                    style: 'currency',
                                    currency: currency.toUpperCase()
                                }}
                            />
                        </I18nProvider>
                    </div>
                </div>
                {tipError && <p className="text-red-500 text-sm mt-2">{tipError}</p>}
            </div>

            <div className="mb-4">
                <label htmlFor="name" style={visuallyHiddenClass}>Your name or nickname (optional)</label>
                <input
                    type="text"
                    id="name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 bg-white text-black placeholder-gray-500 appearance-none"
                    placeholder="Your name or nickname (optional)"
                    aria-label="Your name or nickname (optional)"
                />
            </div>

            <div className="mb-4">
                <label htmlFor="message" style={visuallyHiddenClass}>Your message (optional)</label>
                <textarea
                    id="message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    rows="3"
                    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 bg-white text-black placeholder-gray-500 appearance-none"
                    style={{ backgroundColor: 'white', color: 'black' }}
                    placeholder="Your message (optional)"
                    aria-label="Your message (optional)"
                ></textarea>
            </div>
        </div>
    );
};

export default TipInput;